import { useRouter } from "next/router";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "next-i18next";
import { useGlobalState } from "../../../context/GlobalStateContext";

const LanguageSwitcher = (props) => {
  const { visible } = props;
  const [languageOpen, setLanguageOpen] = useState(false);
  const { language, setLanguage } = useGlobalState();
  const { t: tLayout } = useTranslation("layout");
  const langRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (langRef.current && !langRef.current.contains(event.target as Node)) {
        setLanguageOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  return (
    <div ref={langRef}>
      {/* PC language switcher */}
      <div className="relative hidden lg:flex items-center mx-3">
        <button onClick={() => setLanguageOpen(!languageOpen)}>
          <svg xmlns="http://www.w3.org/2000/svg" id="body_1" width="50" height="50">
            <g transform="matrix(1 0 0 1 0 0)">
              <g>
                <path
                  d="M11.03125 0L38.96875 0C 45.0625 0 50 4.9375 50 11.03125L50 11.03125L50 38.96875C 50 45.0625 45.0625 50 38.96875 50L38.96875 50L11.03125 50C 4.9375 50 0 45.0625 0 38.96875L0 38.96875L0 11.03125C 0 4.9375 4.9375 0 11.03125 0z"
                  stroke="none"
                  fill="#ECECEC"
                  fillRule="nonzero"
                />
                <path
                  d="M19.851562 23.898438L19.117188 26.175781L20.585938 26.175781L19.851562 23.898438z"
                  stroke="none"
                  fill="#676767"
                  fillRule="nonzero"
                />
                <path
                  d="M34.04297 13.96875L22.28125 13.96875L22.28125 17.648438L25.21875 17.648438L25.21875 19.117188L15.664062 19.117188C 14.414062 19.117188 13.457031 20.074219 13.457031 21.324219L13.457031 21.324219L13.457031 29.414062C 13.457031 30.664062 14.414062 31.617188 15.664062 31.617188L15.664062 31.617188L16.398438 31.617188L16.398438 35.367188L21.03125 31.617188L25.957031 31.617188L25.957031 26.46875L34.04297 26.46875C 35.29297 26.46875 36.25 25.511719 36.25 24.261719L36.25 24.261719L36.25 16.175781C 36.25 14.925781 35.29297 13.96875 34.04297 13.96875zM21.398438 28.601562L21.03125 27.425781L18.75 27.425781L18.3125 28.601562L16.542969 28.601562L18.96875 22.0625L20.738281 22.0625L23.164062 28.601562zM32.57422 22.792969L32.57422 24.261719C 31.617188 24.261719 30.585938 23.96875 29.707031 23.53125C 28.824219 23.96875 27.792969 24.1875 26.761719 24.261719L26.761719 24.261719L26.6875 22.792969C 27.207031 22.792969 27.71875 22.71875 28.238281 22.574219C 27.574219 21.914062 27.132812 21.101562 26.914062 20.21875L26.914062 20.21875L28.457031 20.21875C 28.675781 20.882812 29.117188 21.398438 29.632812 21.835938C 30.4375 21.175781 30.957031 20.21875 31.03125 19.117188L31.03125 19.117188L26.617188 19.117188L26.617188 17.648438L28.824219 17.648438L28.824219 16.175781L30.292969 16.175781L30.292969 17.648438L32.71875 17.648438L32.79297 18.382812C 32.867188 19.925781 32.28125 21.46875 31.175781 22.574219C 31.6875 22.71875 32.132812 22.792969 32.57422 22.792969z"
                  stroke="none"
                  fill="#676767"
                  fillRule="nonzero"
                />
              </g>
            </g>
          </svg>
        </button>
        <div
          className={
            !languageOpen
              ? "hidden"
              : "absolute top-14 left-1/2 transform -translate-x-1/2 bg-white flex flex-col border border-gray-200 rounded-lg shadow-lg min-w-[120px] z-10"
          }
        >
          <button
            className={`hover:bg-[#D9D9D9] hover:rounded-lg p-2 text-center ${language === "fr" ? "text-[#233377] font-bold" : ""}`}
            onClick={() => {
              setLanguageOpen(!languageOpen);
              setLanguage("fr");
            }}
          >
            {tLayout("fr_lang")}
          </button>
          <hr className="text-backgroundGrey" />
          <button
            className={`hover:bg-[#D9D9D9] hover:rounded-lg p-2 text-center ${language === "ar" ? "text-[#233377] font-bold" : ""}`}
            onClick={() => {
              setLanguageOpen(!languageOpen);
              setLanguage("ar");
            }}
          >
            {tLayout("ar_lang")}
          </button>
        </div>
      </div>
      {/* Mobile language switcher */}
      <div className={`flex flex-col lg:hidden ${visible ? "" : "hidden"}`}>
        <button
          className={`p-2 rounded-sm text-lg ${language === "fr" ? "text-yellow font-bold" : "text-white"}`}
          onClick={() => setLanguage("fr")}
        >
          {tLayout("fr_lang")}
        </button>

        <button
          className={`p-2 rounded-sm text-lg ${language === "ar" ? "text-yellow font-bold" : "text-white"}`}
          onClick={() => setLanguage("ar")}
        >
          {tLayout("ar_lang")}
        </button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
